<script setup lang="ts">
import ColumnsCardsMobile from '../../components/ColumnsCards/CardsMobile.vue'
import CardsHomepage from '../../components/ColumnsCards/CardsHomepage.vue'
</script>
<template>
  <section class="news-recents">
    
    <div :class="getPage()">
      <div class="block-header block-header--small d-flex align-items-center" v-if="titleVisible">
        <h2 v-text="translate.titleColumns" />
        <p class="d-none d-xl-block subtitle">
          {{ translate.subtitleColumns }}
        </p>
        <router-link
          :to="{ name: 'ColumnsPage', params: { locale } }"
          class="button d-none d-md-inline-flex"
        >
          {{ translate.seeAllColumns }} <i class="icon-arrow-right"></i
        ></router-link>
      </div>
      <div class="tab-scroll">
        <tabs v-model="selectedTab">
          <tab
            v-for="(tab, i) in tabs"
            :key="`t${i}`"
            :val="tab.id"
            :label="tab.category"
            :indicator="true"
          />
        </tabs>
      </div>
      <tab-panels v-model="selectedTab" :animate="true" :swipeable="true">
        <tab-panel v-for="(tab, i) in tabs" :key="`tp${i}`" :val="tab.id">
          <list-itens-column :cards="tab.cards.slice(0,4)" />
          <list-itens-column v-if="!isMobile && titleVisible" :cards="tab.cards.slice(4)" style="margin-top: 5px;"/>
        </tab-panel>
      </tab-panels>

      <div class="cards-home-mobile" v-if="!isMobile()">
        <CardsHomepage :posts="tabsHomepage"/>
      </div>

      <div class="cards-home-mobile" v-if="isMobile()">
        <ColumnsCardsMobile :posts="tabsMobile" v-if="buttonMobile"/>
      </div>

      <div class="row d-flex align-items-center justify-content-center" v-if="buttonMore && tabsHomepage.length >= limit">
        <button type="button" class="more-blog mb-1 p-3 col-lg-3 col-8" @click="readMore">{{ translate.readMore }}
          <font-awesome-icon :icon="['fas', 'arrow-down']" size="md" /></button>
      </div>

      <div class="d-flex justify-content-center button--mobile pb-5" v-if="buttonMobile">
        <router-link :to="{ name: 'ColumnsPage', params: { locale } }" class="button d-md-none">
          {{ translate.seeAllColumns }} <i class="icon-arrow-right"></i>
        </router-link>
      </div>

    </div>
  </section>
</template>

<script lang="ts">
  import { isMobile } from 'views/shared/utils/mobile'
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import translateMain from 'tradutors/menu'
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs'
  import ListItensColumn from './ListItensColumn.vue'
  import api from '../../api'
      
  export default defineComponent({
    name: 'ColunasHome',
    emits: ['getArticleTagId'],    
    components: {
      Tabs,
      Tab,
      TabPanels,
      TabPanel,
      ListItensColumn
    },
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return translateMain.portugues
        } else {
          return translateMain.ingles
        }
      }
    },
    props: ['titleVisible','buttonMobile','buttonMore'],
    data() {
      return {
        tabs: [],
        tabsMobile: [],
        tabsHomepage: [],
        selectedTab: 9999,
        allArticles: null,
        isMobile: isMobile(),
        classDiv: 'container',
        limit: 3
      }
    },
    watch: {
      tabs: function (value) {
        this.selectedTab = value[0].id
      },
      'locale': function () {
        this.getColumns()
        this.getColumnsMobile()        
      },
      'selectedTab': function (value) {
        this.$emit('getArticleTagId', { articleTagId: value })
        this.limit = 3
        this.getColumnsMobile()          
      }
    },
    created() {
      this.getColumns()
    },
    methods: {
      getPage() {
        return this.titleVisible ? 'container ' : 'row bg-light'
      },
      getColumns(){
        api.get(`v1/home/getColumns?language=${this.locale}&limit=10&mobile=${this.isMobile}`).then(({ data }) => {
          this.tabs = data.columns
        })
      },     
      getColumnsMobile(){
        if (this.buttonMobile) {
          api.get(`v1/colunas/getColumns?articletag=${this.selectedTab}&language=${this.locale ?? ''}&limit=${this.limit}&mobile=${this.isMobile}`).then(({ data }) => {
            this.tabsHomepage = data.postsColumns.slice(0,2).concat(data.postsColumns.slice(3,6)).concat(data.postsColumns.slice(7))
            this.tabsMobile = data.postsColumns.slice(0,3).concat(data.postsColumns.slice(3,7)).concat(data.postsColumns.slice(7))
          })
        }
      },     
      async readMore() {
        this.limit += 3
        await this.getColumnsMobile()
      },

    }
  })
</script>

<style scoped lang="css">

  .tab-panels >>> .tab-panel {
    width: 98%
  }

  .news-recents {
    padding-bottom: 0px;
  }
  .news-recents .block-header{
    margin-top: -16px;
    margin-bottom: -7px;
  }

  h2 {
    font-family: 'Bebas-Neue-Light';
    color: #000000;
    font-size: 64px;
    font-weight: 300;
    letter-spacing: 0;
  }

  .block-header >>> h2 {
    margin-right: 34px;
  }

  .subtitle {
    height: 42px;
    color: #5b5858;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 21px;    
  }
  .column-pagination {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .column-pagination .bullet-class {
    background: #ccc;
    width: 8px;
    height: 8px;
    margin: 0 10px;
    border-radius: 10px;
  }

  .column-pagination .bullet-active {
    background: #000;
    width: 12px;
    height: 12px;
  }
  .tabs {
    cursor: pointer;
    margin-left: unset;
  }
  .tabs >>> .active {
    border: 0px;
  }  

  .tabs >>> .active::after {
    content: "";
    background: #b20000;
    position: absolute;
    left: 10%;
    width: 50%;
    height: 3px;
  } 
  .tabs >>> .tab {
    padding: 6px 23px 0px 0px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 14px;
    letter-spacing: 0;
  }
  .tabs >>> .active .tab {
    color: #b20000;
    border-color: #b20000;
    font-weight: bold;    
  }

  .button {
    color: #FFFFFF;
    font-family: "Exo-2";
    font-size: 16px;
    letter-spacing: 0;
    text-align: right;  
    padding-left: 47px;
    padding-right: 49px;    
  }
  
  .more-blog {
    font-size: 1rem !important;
    font-weight: 500;
    background-color: black !important;
    border: 1px solid black !important;
    border-radius: 30px !important;
    color: white;
  }

  .more-blog svg {
    color: #b20;
    margin-left: 8px;
  }  
  /* regras mobile 1400vp */
  @media screen and (max-width: 1400px) {
    .tab-scroll {
      position: relative;
      overflow: auto;
    }
    .tabs {
      width: 1400px;
    }
    .button--mobile {
      margin-bottom: 50px;
    }

  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    h2 {
      font-family: 'Bebas-Neue-Light';
      color: #000000;
      font-size: 48px;
      font-weight: 300;
      letter-spacing: 0;
    }

    .news-recents .block-header{
      margin-top: -30px;
      margin-bottom: 15px;
    }

    .tabs[data-v-77a7dba6] .active {
      border-bottom: 3px solid #FFFFFF;
    }

    .cards-home-mobile {
      margin-top: 30px;
    }    

  }
  
</style>
